export const VIRTUAL_BASKET_LINE_BENEFIT_TYPE = "tsicommon.offer.benefits.GiftWithPurchasePostCheckoutBenefit" as const;
export const CI_COMMIT_SHA = "443d88edc642b5b611cc67cac69b0e4057577ab4" as const;
export const CI_COMMIT_REF_SLUG = "localdev" as const;
export const constants = {
        "thelabui.fields.week.Weekday": {
            "MONDAY": 1,
            "TUESDAY": 2,
            "WEDNESDAY": 3,
            "THURSDAY": 4,
            "FRIDAY": 5,
            "SATURDAY": 6,
            "SUNDAY": 7
        },
        "tsicommon.cms.blocks.sub_blocks.responsive_visibility.ResponsiveVisibilityRules": {
            "DEFAULT": "",
            "SMALL_ONLY": "responsive-visibility--small-only",
            "MEDIUM_ONLY": "responsive-visibility--medium-only",
            "MEDIUM_AND_SMALLER": "responsive-visibility--medium-and-smaller",
            "MEDIUM_AND_LARGER": "responsive-visibility--medium-and-larger",
            "LARGE_ONLY": "responsive-visibility--large-only"
        },
        "tsicommon.cms.blocks.sub_blocks.spacing.SpacingRules": {
            "DEFAULT": "",
            "XS": "spacing--xtra-small",
            "S": "spacing--small",
            "M": "spacing--medium",
            "L": "spacing--large",
            "XL": "spacing--xtra-large"
        },
        "tsicommon.cms.models.rich_navigation.RichNavigationVariantOptions": {
            "DEFAULT": "",
            "TWO_THIRDS_LINK": "rich-navigation--link-collection--two-thirds-link",
            "SINGLE_COLUMN": "rich-navigation--link-collection--single-column",
            "HEART": "rich-navigation--link-collection--heart",
            "NO_TITLE": "rich-navigation--link-collection--no-title",
            "INSPIRATION": "rich-navigation--link-collection--inspiration"
        },
        "tsicommon.financing.constants.HousingStatus": {
            "RENT": "Rent",
            "OWN": "Own",
            "OTHER": "Other"
        },
        "tsicommon.financing.constants.CreditAppStatus": {
            "UNKNOWN": "",
            "OFFERED": "OFFERED",
            "APPROVED": "APPROVED",
            "PENDING": "PENDING",
            "DENIED": "DENIED",
            "ERROR": "ERROR",
            "EXISTING_CARDHOLDER": "EC"
        },
        "tsicommon.financing.constants.DocumentType": {
            "SUMMARY_OF_CREDIT_TERMS": "SUMMARY_OF_CREDIT_TERMS",
            "OPT_OUT": "OPT_OUT",
            "CARDHOLDER_AGREEMENT": "CARDHOLDER_AGREEMENT",
            "AUTO_DEDUCT_DISCLOSURE": "AUTO_DEDUCT_DISCLOSURE",
            "CONSENT_TO_ELECTRONIC_DISCLOSURE": "CONSENT_TO_ELECTRONIC_DISCLOSURE",
            "APPLICATION_DISCLOSURE": "APPLICATION_DISCLOSURE"
        },
        "tsicommon.financing.constants.DocumentFormat": {
            "PDF": "application/pdf",
            "HTML": "text/html"
        },
        "tsicommon.financing.constants.EmploymentStatus": {
            "EMPLOYED": "Employed",
            "SELF_EMPLOYED": "Self Employed",
            "RETIRED": "Retired",
            "UNEMPLOYED_WITH_INCOME": "Unemployed with income",
            "UNEMPLOYED_WITHOUT_INCOME": "Unemployed without income"
        },
        "tsicommon.financing.constants.MarriedStatus": {
            "MARRIED": "MARRIED",
            "UNMARRIED": "UNMARRIED"
        },
        "tsicommon.financing.constants.CitizenshipStatus": {
            "US_CITIZEN": "U.S. Citizen",
            "US_PERMANENT_RESIDENT": "U.S. Lawful Permanent Resident",
            "NON_RESIDENT_ALIEN": "Non-Resident Alien"
        },
        "VIRTUAL_BASKET_LINE_BENEFIT_TYPE": "tsicommon.offer.benefits.GiftWithPurchasePostCheckoutBenefit",
        "CI_COMMIT_SHA": "443d88edc642b5b611cc67cac69b0e4057577ab4",
        "CI_COMMIT_REF_SLUG": "localdev"
    } as const;
